import { applyMiddleware, combineReducers, compose, legacy_createStore } from "redux";
import thunk from "redux-thunk";
import { auth_reducer } from "./auth/auth.reducer";
import { app_reducer } from "./app/app.reducer";
import { po_backlog_reducer } from "./po_backlog/po_backlog.reducer";

const reducers_combined = {
  auth: auth_reducer,
  app: app_reducer,
  po_backlog_reducer: po_backlog_reducer
};

const root_reducer = combineReducers(reducers_combined);

const middleware = applyMiddleware(thunk);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const reducer = legacy_createStore(
  root_reducer,
  composeEnhancers(middleware)
);